// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonAdd_button__Ko86N","circle":"ButtonAdd_circle__PNpge","icon":"ButtonAdd_icon__5a5xJ","label":"ButtonAdd_label__6GZ6B"};